// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"302":"9eec608d2253bf2c","487":"275056624dd7c658","868":"5f8f725b18d876cd","921":"c780ebaf8447ac85"}[chunkId] + ".js";
};